import { inject, Injectable, signal } from '@angular/core';
import { config } from '@core/interfaces/api_baseurl';
import { tap } from 'rxjs';
import { NotificationItem } from '@page/notification/helper';
import { ApiService } from '@core/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  _ApiService: ApiService = inject(ApiService);
  countSignal = signal<number>(0);
  notificationListSignal = signal<NotificationItem[]>([]);

  constructor() { }

  notificationList() {
    return this._ApiService.post(config.notification.list_url).pipe(tap((res: any) => {
      this.notificationListSignal.set(res.data);
    }
    ))
  }
  getNotificationCount() {
    return this._ApiService.skipLoader('post', config.auth.getNotification).pipe(tap((count: any) => {
      this.countSignal.set(count.data);

    }))
  }
  readMarkNotification(formdata: any) {
    return this._ApiService.post(config.notification.readNotification, formdata);
  }
}
